'use strict';

namespace Core {
    class HotelContentCard {
        // Attr
        model: Hotels.StaticHotel;
        click: () => void;
        href: string;
        header: string;
        teaserPrice: string;
    }
    angular
        .module('core')
        .directive('hotelContentCard', (): ng.IDirective => {
            return {
                restrict: 'E',
                scope: {},
                controller: HotelContentCard,
                controllerAs: 'hc',
                replace: true,
                bindToController: {
                    model: '=',
                    click: '&',
                    header: '@',
                    href: '@',
                    teaserPrice: '@'
                },
                templateUrl: 'partials/home/directivetemplate?type=HotelContentCard'
            };
        });
}
